import Vue from "vue";
import { newLogger } from "@/utils/util";
import network from "../../../utils/network";

let logger = newLogger("LimitStore");

const urls = {
  getList: (query) =>
    `/bnpl/customer-limit/merchant/search${query ? `?${query}` : ""}`,
  postDraft: `/bnpl/customer-limit/draft`,
  getCustomerLimit: (limitId) => `/bnpl/customer-limit/merchant/${limitId}`,
  getIsLimit: `/bnpl/customer-limit/is_limit`,
};

/**
 * Customer Limit store
 */

const initState = () => {
  return {
    list: [],
    data: {},
    isLimit: {},
  };
};

const actions = {
  fetchList: async ({ commit }, query) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.getList(query));
      commit("saveList", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  fetchOne: async ({ commit }, limitId) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.getCustomerLimit(limitId));
      commit("saveOne", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  fetchIsLimit: async ({ commit }) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.getIsLimit);
      commit("saveIsLimit", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  createDraft: async (_, payload) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.post(urls.postDraft, payload);
      console.log(data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
};

const mutations = {
  saveList: (state, listData) => {
    Vue.set(state, "list", listData);
  },
  saveOne: (state, data) => {
    Vue.set(state, "data", data);
  },
  saveIsLimit: (state, data) => {
    Vue.set(state, "isLimit", data);
  },
};

const getters = {
  list: (state) => {
    return state.list;
  },
  get: (state) => {
    return state.data;
  },
  getLimitLanes: (state) => {
    return state.data.limitLanes;
  },
  isLimit: (state) => {
    return state.isLimit.isLimit;
  },
  isCustomerLimit: (state) => {
    return state.isLimit.isCustomerLimit;
  },
  isB2bLimit: (state) => {
    return state.isLimit.isB2bLimit;
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
